export default __webpack_public_path__ + "static/media/destin1.85031f06.jpg";